import ticktockDesktop from "../../images/Portfolio/thumbnails/tiktokDesktop.jpg";
import sonyDesktop from "../../images/Portfolio/thumbnails/sonyDesktop.jpg";
import savage from "../../images/Portfolio/thumbnails/savage.jpg";
import LV from "../../images/Portfolio/thumbnails/LV.jpg";
import burningMan from "../../images/Portfolio/thumbnails/burningMan.jpg";
import disneyEarth from "../../images/Portfolio/thumbnails/disneyEarth.jpg";
import disneyCloud from "../../images/Portfolio/thumbnails/disneyCloud.jpg";
import oneofaKindWedding from "../../images/Portfolio/thumbnails/oneofaKindWedding.jpg";
import nickJonas from "../../images/Portfolio/thumbnails/nickJonas.jpg";
import nationalGeographic from "../../images/Portfolio/thumbnails/nationalGeographic.jpg";
import hboHacks from "../../images/Portfolio/thumbnails/hboHacks.jpg";
import hboEuphoria from "../../images/Portfolio/thumbnails/hboEuphoria.jpg";
import disneyBigShot from "../../images/Portfolio/thumbnails/disneyBigShot.jpg";
import rayeLifeShow from "../../images/Portfolio/thumbnails/rayeLifeShow.jpg";
import deltaGrammy from "../../images/Portfolio/thumbnails/deltaGrammy.jpg";
import lalaHathaway from "../../images/Portfolio/thumbnails/lalaHathaway.jpg";
import betMusicParty from "../../images/Portfolio/thumbnails/betMusicParty.jpg";
import amazonMusicGenMex from "../../images/Portfolio/thumbnails/amazonMusicGenMex.jpg";
import infectedMushroom from "../../images/Portfolio/thumbnails/infectedMushroom.jpg";
import theBlackPowerLiveStream from "../../images/Portfolio/thumbnails/theBlackPowerLiveStream.jpg";
import alisonJacksonMelissaRiversInterview from "../../images/Portfolio/thumbnails/alisonJacksonMelissaRiversInterview.jpg";
import InterviewProductionHboChad from "../../images/Portfolio/thumbnails/InterviewProductionHboChad.jpg";
import videoProductionInvisiblePortraits from "../../images/Portfolio/thumbnails/videoProductionInvisiblePortraits.jpg";
import teenVogueSummit from "../../images/Portfolio/thumbnails/teenVogueSummit.jpg";
import solanaHackerHouse from "../../images/Portfolio/thumbnails/solanaHackerHouse.jpg";
import ekoAppLaunch from "../../images/Portfolio/thumbnails/ekoAppLaunch.jpg";
import betAwards from "../../images/Portfolio/thumbnails/betAwards.jpg";
import nbaLive from "../../images/Portfolio/thumbnails/nbaLive.jpg";
import goCampaign from "../../images/Portfolio/thumbnails/goCampaign.jpg";
import netflixSquidGame from "../../images/Portfolio/thumbnails/netflixSquidGame.jpg";
import peacockDr from "../../images/Portfolio/thumbnails/peacockDr.jpg";
import theFriendsReunion from "../../images/Portfolio/thumbnails/theFriendsReunion.jpg";
import usaBriarpatch from "../../images/Portfolio/thumbnails/usaBriarpatch.jpg";
import usaQueenOfTheSouth from "../../images/Portfolio/thumbnails/usaQueenOfTheSouth.jpg";
import disneyZombies from "../../images/Portfolio/thumbnails/disneyZombies.jpg";
import amazonePrimeTheVoyeurs from "../../images/Portfolio/thumbnails/amazonePrimeTheVoyeurs.jpg";
import netflixStrangerThing from "../../images/Portfolio/thumbnails/netflixStrangerThing.jpg";
import huluOnlyMurders from "../../images/Portfolio/thumbnails/huluOnlyMurders.jpg";
import hboSuccession from "../../images/Portfolio/thumbnails/hboSuccession.jpg";
import netfixArmyOfTheDead from "../../images/Portfolio/thumbnails/netfixArmyOfTheDead.jpg";
import fxHuluReservationDogs from "../../images/Portfolio/thumbnails/fxHuluReservationDogs.jpg";
import nationalGeographicTheRescue from "../../images/Portfolio/thumbnails/nationalGeographicTheRescue.jpg";
import huluTheGreat from "../../images/Portfolio/thumbnails/huluTheGreat.jpg";
import netflixGraceAndFrankie from "../../images/Portfolio/thumbnails/netflixGraceAndFrankie.jpg";
import fxAmericanCrimeStoryVersace from "../../images/Portfolio/thumbnails/fxAmericanCrimeStoryVersace.jpg";
import hboWeOwnThisCity from "../../images/Portfolio/thumbnails/hboWeOwnThisCity.jpg";
import iggyAzaleaForEmber from "../../images/Portfolio/thumbnails/iggyAzaleaForEmber.jpg";
import bigSeanAtPuma from "../../images/Portfolio/thumbnails/bigSeanAtPuma.jpg";
import localNativesForSpotify from "../../images/Portfolio/thumbnails/localNativesForSpotify.jpg";
import leonBridgesAtDeltaGrammyParty from "../../images/Portfolio/thumbnails/leonBridgesAtDeltaGrammyParty.jpg";
import piso21AtLatinAMAsFest from "../../images/Portfolio/thumbnails/piso21AtLatinAMAsFest.jpg";
import ukraineFilmFestival from "../../images/Portfolio/thumbnails/ukraineFilmFestival.jpg";
import clioCanabisAwards from "../../images/Portfolio/thumbnails/clioCanabisAwards.jpg";
import starsSummit from "../../images/Portfolio/thumbnails/starsSummit.jpg";

import comment1 from "../../images/Portfolio/comment1.jpg";
import comment2 from "../../images/Portfolio/comment2.jpg";
import comment3 from "../../images/Portfolio/comment3.jpg";
import comment4 from "../../images/Portfolio/comment4.jpg";

import ticktock1 from "../../images/Portfolio/tiktok/tiktok1.jpg";
import ticktock2 from "../../images/Portfolio/tiktok/tiktok2.jpg";
import ticktock3 from "../../images/Portfolio/tiktok/tiktok3.jpg";
import ticktock4 from "../../images/Portfolio/tiktok/tiktok4.jpg";
import ticktock5 from "../../images/Portfolio/tiktok/tiktok5.jpg";
import sony1 from "../../images/Portfolio/sony/sony1.jpg";
import sony2 from "../../images/Portfolio/sony/sony2.jpg";
import sony3 from "../../images/Portfolio/sony/sony3.jpg";
import sony4 from "../../images/Portfolio/sony/sony4.jpg";
import sony5 from "../../images/Portfolio/sony/sony5.jpg";
import sony6 from "../../images/Portfolio/sony/sony6.jpg";
import savage1 from "../../images/Portfolio/savage/savage1.jpg";
import savage2 from "../../images/Portfolio/savage/savage2.jpg";
import savage3 from "../../images/Portfolio/savage/savage3.jpg";
import savage4 from "../../images/Portfolio/savage/savage4.jpg";
import savage5 from "../../images/Portfolio/savage/savage5.jpg";
import savage6 from "../../images/Portfolio/savage/savage6.jpg";
import savage7 from "../../images/Portfolio/savage/savage7.jpg";
import LV1 from "../../images/Portfolio/LV/LV1.jpg";
import LV2 from "../../images/Portfolio/LV/LV2.jpg";
import LV3 from "../../images/Portfolio/LV/LV3.jpg";
import LV4 from "../../images/Portfolio/LV/LV4.jpg";
import LV5 from "../../images/Portfolio/LV/LV5.jpg";
import LV6 from "../../images/Portfolio/LV/LV6.jpg";
import burningMan1 from "../../images/Portfolio/burningMan/burningMan1.jpg";
import burningMan2 from "../../images/Portfolio/burningMan/burningMan2.jpg";
import burningMan3 from "../../images/Portfolio/burningMan/burningMan3.jpg";
import burningMan4 from "../../images/Portfolio/burningMan/burningMan4.jpg";
import burningMan5 from "../../images/Portfolio/burningMan/burningMan5.jpg";
import burningMan6 from "../../images/Portfolio/burningMan/burningMan6.jpg";
import burningMan7 from "../../images/Portfolio/burningMan/burningMan7.jpg";
import disneyEarth1 from "../../images/Portfolio/disneyEarth/disneyEarth1.jpg";
import disneyEarth2 from "../../images/Portfolio/disneyEarth/disneyEarth2.jpg";
import disneyCloud1 from "../../images/Portfolio/disneyCloud/disneyCloud1.jpg";
import disneyCloud2 from "../../images/Portfolio/disneyCloud/disneyCloud2.jpg";
import disneyCloud3 from "../../images/Portfolio/disneyCloud/disneyCloud3.jpg";
import disneyCloud4 from "../../images/Portfolio/disneyCloud/disneyCloud4.jpg";
import disneyCloud5 from "../../images/Portfolio/disneyCloud/disneyCloud5.jpg";
import disneyCloud6 from "../../images/Portfolio/disneyCloud/disneyCloud6.jpg";
import oneofaKindWedding1 from "../../images/Portfolio/oneofaKindWedding/oneofaKindWedding11.mp4";
import oneofaKindWedding2 from "../../images/Portfolio/oneofaKindWedding/oneofaKindWedding2.jpg";
import nickJonas1 from "../../images/Portfolio/nickJonas/nickJonas11.mp4";
import nationalGeographic1 from "../../images/Portfolio/nationalGeographic/nationalGeographic1.mp4";
import nationalGeographic2 from "../../images/Portfolio/nationalGeographic/nationalGeographic2.jpg";
import hboHacks1 from "../../images/Portfolio/hboHacks/hboHacks1.jpg";
import hboHacks2 from "../../images/Portfolio/hboHacks/hboHacks2.jpg";
import hboHacks3 from "../../images/Portfolio/hboHacks/hboHacks3.jpg";
import hboHacks4 from "../../images/Portfolio/hboHacks/hboHacks4.jpg";
import hboHacks5 from "../../images/Portfolio/hboHacks/hboHacks5.jpg";
import hboEuphoria1 from "../../images/Portfolio/hboEuphoria/hboEuphoria1.jpg";
import hboEuphoria2 from "../../images/Portfolio/hboEuphoria/hboEuphoria2.jpg";
import hboEuphoria3 from "../../images/Portfolio/hboEuphoria/hboEuphoria3.jpg";
import disneyBigShot1 from "../../images/Portfolio/disneyBigShot/disneyBigShot1.jpg";
import disneyBigShot2 from "../../images/Portfolio/disneyBigShot/disneyBigShot2.jpg";
import disneyBigShot3 from "../../images/Portfolio/disneyBigShot/disneyBigShot3.jpg";
import disneyBigShot4 from "../../images/Portfolio/disneyBigShot/disneyBigShot4.jpg";
import rayeLifeShow1 from "../../images/Portfolio/rayeLifeShow/rayeLifeShow1.jpg";
import rayeLifeShow2 from "../../images/Portfolio/rayeLifeShow/rayeLifeShow2.jpg";
import rayeLifeShow3 from "../../images/Portfolio/rayeLifeShow/rayeLifeShow3.jpg";
import rayeLifeShow4 from "../../images/Portfolio/rayeLifeShow/rayeLifeShow4.jpg";
import deltaGrammy1 from "../../images/Portfolio/deltaGrammy/deltaGrammy1.jpg";
import lalaHathaway1 from "../../images/Portfolio/lalaHathaway/lalaHathaway1.jpg";
import lalaHathaway2 from "../../images/Portfolio/lalaHathaway/lalaHathaway2.jpg";
import lalaHathaway3 from "../../images/Portfolio/lalaHathaway/lalaHathaway3.jpg";
import betMusicParty1 from "../../images/Portfolio/betMusicParty/betMusicParty1.jpg";
import betMusicParty2 from "../../images/Portfolio/betMusicParty/betMusicParty2.jpg";
import amazonMusicGenMex1 from "../../images/Portfolio/amazonMusicGenMex/amazonMusicGenMex1.jpg";
import amazonMusicGenMex2 from "../../images/Portfolio/amazonMusicGenMex/amazonMusicGenMex2.jpg";
import amazonMusicGenMex3 from "../../images/Portfolio/amazonMusicGenMex/amazonMusicGenMex3.jpg";
import amazonMusicGenMex4 from "../../images/Portfolio/amazonMusicGenMex/amazonMusicGenMex4.jpg";
import amazonMusicGenMex5 from "../../images/Portfolio/amazonMusicGenMex/amazonMusicGenMex5.jpg";
import infectedMushroom1 from "../../images/Portfolio/infectedMushroom/infectedMushroom1.jpg";
import infectedMushroom2 from "../../images/Portfolio/infectedMushroom/infectedMushroom2.jpg";
import infectedMushroom3 from "../../images/Portfolio/infectedMushroom/infectedMushroom3.jpg";
import infectedMushroom4 from "../../images/Portfolio/infectedMushroom/infectedMushroom4.jpg";
import theBlackPowerLiveStream1 from "../../images/Portfolio/theBlackPowerLiveStream/theBlackPowerLiveStream1.jpg";
import theBlackPowerLiveStream2 from "../../images/Portfolio/theBlackPowerLiveStream/theBlackPowerLiveStream2.jpg";
import alisonJacksonMelissaRiversInterview1 from "../../images/Portfolio/alisonJacksonMelissaRiversInterview/alisonJacksonMelissaRiversInterview1.jpg";
import alisonJacksonMelissaRiversInterview2 from "../../images/Portfolio/alisonJacksonMelissaRiversInterview/alisonJacksonMelissaRiversInterview2.jpg";
import alisonJacksonMelissaRiversInterview3 from "../../images/Portfolio/alisonJacksonMelissaRiversInterview/alisonJacksonMelissaRiversInterview3.jpg";
import InterviewProductionHboChad1 from "../../images/Portfolio/InterviewProductionHboChad/InterviewProductionHboChad1.jpg";
import InterviewProductionHboChad2 from "../../images/Portfolio/InterviewProductionHboChad/InterviewProductionHboChad2.jpg";
import InterviewProductionHboChad3 from "../../images/Portfolio/InterviewProductionHboChad/InterviewProductionHboChad3.jpg";
import InterviewProductionHboChad4 from "../../images/Portfolio/InterviewProductionHboChad/InterviewProductionHboChad4.jpg";
import videoProductionInvisiblePortraits1 from "../../images/Portfolio/videoProductionInvisiblePortraits/videoProductionInvisiblePortraits1.jpg";
import videoProductionInvisiblePortraits2 from "../../images/Portfolio/videoProductionInvisiblePortraits/videoProductionInvisiblePortraits2.jpg";
import videoProductionInvisiblePortraits3 from "../../images/Portfolio/videoProductionInvisiblePortraits/videoProductionInvisiblePortraits3.jpg";
import videoProductionInvisiblePortraits4 from "../../images/Portfolio/videoProductionInvisiblePortraits/videoProductionInvisiblePortraits4.jpg";
import videoProductionInvisiblePortraits5 from "../../images/Portfolio/videoProductionInvisiblePortraits/videoProductionInvisiblePortraits5.jpg";
import videoProductionInvisiblePortraits6 from "../../images/Portfolio/videoProductionInvisiblePortraits/videoProductionInvisiblePortraits6.jpg";
import teenVogueSummit1 from "../../images/Portfolio/teenVogueSummit/teenVogueSummit1.jpg";
import teenVogueSummit2 from "../../images/Portfolio/teenVogueSummit/teenVogueSummit2.jpg";
import solanaHackerHouse1 from "../../images/Portfolio/solanaHackerHouse/solanaHackerHouse1.jpg";
import solanaHackerHouse2 from "../../images/Portfolio/solanaHackerHouse/solanaHackerHouse2.jpg";
import solanaHackerHouse3 from "../../images/Portfolio/solanaHackerHouse/solanaHackerHouse3.jpg";
import ekoAppLaunch1 from "../../images/Portfolio/ekoAppLaunch/ekoAppLaunch1.jpg";
import ekoAppLaunch2 from "../../images/Portfolio/ekoAppLaunch/ekoAppLaunch2.jpg";
import ekoAppLaunch3 from "../../images/Portfolio/ekoAppLaunch/ekoAppLaunch3.jpg";
import betAwards1 from "../../images/Portfolio/betAwards/betAwards1.jpg";
import betAwards2 from "../../images/Portfolio/betAwards/betAwards2.jpg";
import betAwards3 from "../../images/Portfolio/betAwards/betAwards3.jpg";
import nbaLive1 from "../../images/Portfolio/nbaLive/nbaLive1.jpg";
import nbaLive2 from "../../images/Portfolio/nbaLive/nbaLive2.jpg";
import nbaLive3 from "../../images/Portfolio/nbaLive/nbaLive3.jpg";
import nbaLive4 from "../../images/Portfolio/nbaLive/nbaLive4.jpg";
import nbaLive5 from "../../images/Portfolio/nbaLive/nbaLive5.jpg";
import goCampaign1 from "../../images/Portfolio/goCampaign/goCampaign1.jpg";
import netflixSquidGame1 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame1.jpg";
import netflixSquidGame2 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame2.jpg";
import netflixSquidGame3 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame3.jpg";
import netflixSquidGame4 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame4.jpg";
import netflixSquidGame5 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame5.jpg";
import netflixSquidGame6 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame6.jpg";
import netflixSquidGame7 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame7.jpg";
import netflixSquidGame8 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame8.jpg";
import netflixSquidGame9 from "../../images/Portfolio/netflixSquidGame/netflixSquidGame9.jpg";
import peacockDr1 from "../../images/Portfolio/peacockDr/peacockDr1.jpg";
import peacockDr2 from "../../images/Portfolio/peacockDr/peacockDr2.jpg";
import peacockDr3 from "../../images/Portfolio/peacockDr/peacockDr3.jpg";
import theFriendsReunion1 from "../../images/Portfolio/theFriendsReunion/theFriendsReunion1.jpg";
import theFriendsReunion2 from "../../images/Portfolio/theFriendsReunion/theFriendsReunion2.jpg";
import usaBriarpatch1 from "../../images/Portfolio/usaBriarpatch/usaBriarpatch1.jpg";
import usaBriarpatch2 from "../../images/Portfolio/usaBriarpatch/usaBriarpatch2.jpg";
import usaBriarpatch3 from "../../images/Portfolio/usaBriarpatch/usaBriarpatch3.jpg";
import usaBriarpatch4 from "../../images/Portfolio/usaBriarpatch/usaBriarpatch4.jpg";
import usaQueenOfTheSouth1 from "../../images/Portfolio/usaQueenOfTheSouth/usaQueenOfTheSouth1.jpg";
import usaQueenOfTheSouth2 from "../../images/Portfolio/usaQueenOfTheSouth/usaQueenOfTheSouth2.jpg";
import disneyZombies1 from "../../images/Portfolio/disneyZombies/disneyZombies1.jpg";
import disneyZombies2 from "../../images/Portfolio/disneyZombies/disneyZombies2.jpg";
import disneyZombies3 from "../../images/Portfolio/disneyZombies/disneyZombies3.jpg";
import disneyZombies4 from "../../images/Portfolio/disneyZombies/disneyZombies4.jpg";
import disneyZombies5 from "../../images/Portfolio/disneyZombies/disneyZombies5.jpg";
import disneyZombies6 from "../../images/Portfolio/disneyZombies/disneyZombies6.jpg";
import disneyZombies7 from "../../images/Portfolio/disneyZombies/disneyZombies7.jpg";
import disneyZombies8 from "../../images/Portfolio/disneyZombies/disneyZombies8.jpg";
import disneyZombies9 from "../../images/Portfolio/disneyZombies/disneyZombies9.jpg";
import disneyZombies10 from "../../images/Portfolio/disneyZombies/disneyZombies10.jpg";
import amazonePrimeTheVoyeurs1 from "../../images/Portfolio/amazonePrimeTheVoyeurs/amazonePrimeTheVoyeurs1.jpg";
import amazonePrimeTheVoyeurs2 from "../../images/Portfolio/amazonePrimeTheVoyeurs/amazonePrimeTheVoyeurs2.jpg";
import amazonePrimeTheVoyeurs3 from "../../images/Portfolio/amazonePrimeTheVoyeurs/amazonePrimeTheVoyeurs3.jpg";
import amazonePrimeTheVoyeurs4 from "../../images/Portfolio/amazonePrimeTheVoyeurs/amazonePrimeTheVoyeurs4.jpg";
import netflixStrangerThing1 from "../../images/Portfolio/netflixStrangerThing/netflixStrangerThing1.jpg";
import huluOnlyMurders1 from "../../images/Portfolio/huluOnlyMurders/huluOnlyMurders1.jpg";
import huluOnlyMurders2 from "../../images/Portfolio/huluOnlyMurders/huluOnlyMurders2.jpg";
import hboSuccession1 from "../../images/Portfolio/hboSuccession/hboSuccession1.jpg";
import hboSuccession2 from "../../images/Portfolio/hboSuccession/hboSuccession2.jpg";
import netfixArmyOfTheDead1 from "../../images/Portfolio/netfixArmyOfTheDead/netfixArmyOfTheDead1.jpg";
import netfixArmyOfTheDead2 from "../../images/Portfolio/netfixArmyOfTheDead/netfixArmyOfTheDead2.jpg";
import fxHuluReservationDogs1 from "../../images/Portfolio/fxHuluReservationDogs/fxHuluReservationDogs1.jpg";
import fxHuluReservationDogs2 from "../../images/Portfolio/fxHuluReservationDogs/fxHuluReservationDogs2.jpg";
import nationalGeographicTheRescue1 from "../../images/Portfolio/nationalGeographicTheRescue/nationalGeographicTheRescue1.jpg";
import nationalGeographicTheRescue2 from "../../images/Portfolio/nationalGeographicTheRescue/nationalGeographicTheRescue2.jpg";
import huluTheGreat1 from "../../images/Portfolio/huluTheGreat/huluTheGreat1.jpg";
import huluTheGreat2 from "../../images/Portfolio/huluTheGreat/huluTheGreat2.jpg";
import netflixGraceAndFrankie1 from "../../images/Portfolio/netflixGraceAndFrankie/netflixGraceAndFrankie1.jpg";
import netflixGraceAndFrankie2 from "../../images/Portfolio/netflixGraceAndFrankie/netflixGraceAndFrankie2.jpg";
import fxAmericanCrimeStoryVersace1 from "../../images/Portfolio/fxAmericanCrimeStoryVersace/fxAmericanCrimeStoryVersace1.jpg";
import fxAmericanCrimeStoryVersace2 from "../../images/Portfolio/fxAmericanCrimeStoryVersace/fxAmericanCrimeStoryVersace2.jpg";
import hboWeOwnThisCity1 from "../../images/Portfolio/hboWeOwnThisCity/hboWeOwnThisCity1.jpg";
import hboWeOwnThisCity2 from "../../images/Portfolio/hboWeOwnThisCity/hboWeOwnThisCity2.jpg";
import hboWeOwnThisCity3 from "../../images/Portfolio/hboWeOwnThisCity/hboWeOwnThisCity3.jpg";
import iggyAzaleaForEmber1 from "../../images/Portfolio/iggyAzaleaForEmber/iggyAzaleaForEmber1.jpg";
import bigSeanAtPuma1 from "../../images/Portfolio/bigSeanAtPuma/bigSeanAtPuma1.jpg";
import localNativesForSpotify1 from "../../images/Portfolio/localNativesForSpotify/localNativesForSpotify1.jpg";
import localNativesForSpotify2 from "../../images/Portfolio/localNativesForSpotify/localNativesForSpotify2.jpg";
import localNativesForSpotify3 from "../../images/Portfolio/localNativesForSpotify/localNativesForSpotify3.jpg";
import leonBridgesAtDeltaGrammyParty1 from "../../images/Portfolio/leonBridgesAtDeltaGrammyParty/leonBridgesAtDeltaGrammyParty1.jpg";
import leonBridgesAtDeltaGrammyParty2 from "../../images/Portfolio/leonBridgesAtDeltaGrammyParty/leonBridgesAtDeltaGrammyParty2.jpg";
import piso21AtLatinAMAsFest1 from "../../images/Portfolio/piso21AtLatinAMAsFest/piso21AtLatinAMAsFest1.jpg";
import piso21AtLatinAMAsFest2 from "../../images/Portfolio/piso21AtLatinAMAsFest/piso21AtLatinAMAsFest2.jpg";
import piso21AtLatinAMAsFest3 from "../../images/Portfolio/piso21AtLatinAMAsFest/piso21AtLatinAMAsFest3.jpg";
import piso21AtLatinAMAsFest4 from "../../images/Portfolio/piso21AtLatinAMAsFest/piso21AtLatinAMAsFest4.jpg";
import piso21AtLatinAMAsFest5 from "../../images/Portfolio/piso21AtLatinAMAsFest/piso21AtLatinAMAsFest5.jpg";
import ukraineFilmFestival1 from "../../images/Portfolio/ukraineFilmFestival/ukraineFilmFestival1.jpg";
import ukraineFilmFestival2 from "../../images/Portfolio/ukraineFilmFestival/ukraineFilmFestival2.jpg";
import clioCanabisAwards1 from "../../images/Portfolio/clioCanabisAwards/clioCanabisAwards1.jpg";
import clioCanabisAwards2 from "../../images/Portfolio/clioCanabisAwards/clioCanabisAwards2.jpg";
import starsSummit1 from "../../images/Portfolio/starsSummit/starsSummit1.mp4";

export const commentsPictures = [
  {
    image: comment1,
    commentatorName: "MAX COLT - FOUNDER AT THE F-RENDER",
    commentText:
      "i've been cooperating with Masters for years and have nothing negative to say. Satisfaction only. Anytime. Anywhere. We have been made large nmber of events, small ones and enough big arrangements.  I will not let them down. Stay perfect!",
  },
  {
    image: comment2,
    commentatorName: "Chuck - Event Producer",
    commentText:
      "The show went perfectly, even with some last minute changes we made. Every member of the crew was professional and helpful. Rowland was a great help with every request we made. My thanks for all your contributions to our success. We look forward to working with you again in the future.",
  },
  {
    image: comment3,
    commentatorName: "Derek- Special Events Manager",
    commentText:
      "Thank you so much for all of your help making our event last night a success. Hope to work with you all again soon!",
  },
  {
    image: comment4,
    commentatorName: "Danielle - Event Producer",
    commentText:
      "Hi! Last night the Academy Museum looked incredible! Thank you for the attention to details that went into making the event a true success! Please relay our thanks to the entire team!",
  },
];

export const portfolioPictures = [
  {
    id: 0,
    image: starsSummit,
    eventName: "Stars summit",
    hashtag: "corporate events",
    subPictures: [starsSummit1],
  },
  {
    id: 1,
    image: rayeLifeShow,
    eventName: "Raye - life show",
    hashtag: "live show",
    subPictures: [rayeLifeShow1, rayeLifeShow2, rayeLifeShow3, rayeLifeShow4],
  },

  {
    id: 2,
    image: clioCanabisAwards,
    eventName: "Clio Canabis Awards",
    hashtag: "corporate events",
    subPictures: [clioCanabisAwards1, clioCanabisAwards2],
  },

  {
    id: 3,
    image: LV,
    eventName: "Louis vuitton",
    hashtag: "special events",
    subPictures: [LV1, LV2, LV3, LV4, LV5, LV6],
  },
  {
    id: 4,
    image: sonyDesktop,
    eventName: "Sony music grammy party",
    hashtag: "special events",
    subPictures: [sony1, sony2, sony3, sony4, sony5, sony6],
  },
  {
    id: 5,
    image: oneofaKindWedding,
    eventName: "One of a Kind Wedding",
    hashtag: "special events",
    subPictures: [oneofaKindWedding1, oneofaKindWedding2],
  },
  {
    id: 6,
    image: burningMan,
    eventName: "Burning Man",
    hashtag: "special events",
    subPictures: [
      burningMan1,
      burningMan2,
      burningMan3,
      burningMan4,
      burningMan5,
      burningMan6,
      burningMan7,
    ],
  },
  {
    id: 7,
    image: savage,
    eventName: "Savage x fenty",
    hashtag: "special events",
    subPictures: [
      savage1,
      savage2,
      savage3,
      savage4,
      savage5,
      savage6,
      savage7,
    ],
  },
  {
    id: 8,
    image: usaBriarpatch,
    eventName: "USA Briarpatch",
    hashtag: "premiers",
    subPictures: [
      usaBriarpatch1,
      usaBriarpatch2,
      usaBriarpatch3,
      usaBriarpatch4,
    ],
  },

  {
    id: 9,
    image: ticktockDesktop,
    eventName: "tik tok awards",
    hashtag: "corporate events",
    subPictures: [ticktock1, ticktock2, ticktock3, ticktock4, ticktock5],
  },

  {
    id: 36,
    image: usaQueenOfTheSouth,
    eventName: "USA Queen of the South",
    hashtag: "premiers",
    subPictures: [usaQueenOfTheSouth1, usaQueenOfTheSouth2],
  },

  {
    id: 11,
    image: disneyEarth,
    eventName: "Disney + EARTH",
    hashtag: "special events",
    subPictures: [disneyEarth1, disneyEarth2],
  },
  {
    id: 12,
    image: disneyCloud,
    eventName: "Disney + Cloud Premiere",
    hashtag: "special events",
    subPictures: [
      disneyCloud1,
      disneyCloud2,
      disneyCloud3,
      disneyCloud4,
      disneyCloud5,
      disneyCloud6,
    ],
  },
  {
    id: 13,
    image: nickJonas,
    eventName: "Nick Jonas at Cedar-sinai",
    hashtag: "special events",
    subPictures: [nickJonas1],
  },
  {
    id: 14,
    image: nationalGeographic,
    eventName: "National Geographic",
    hashtag: "special events",
    subPictures: [nationalGeographic1, nationalGeographic2],
  },
  {
    id: 15,
    image: hboHacks,
    eventName: "Hbo hacks",
    hashtag: "premiers",
    subPictures: [hboHacks1, hboHacks2, hboHacks3, hboHacks4, hboHacks5],
  },
  {
    id: 16,
    image: hboEuphoria,
    eventName: "HBO Euphoria",
    hashtag: "premiers",
    subPictures: [hboEuphoria1, hboEuphoria2, hboEuphoria3],
  },
  {
    id: 17,
    image: disneyBigShot,
    eventName: "Disney + Big Shot",
    hashtag: "premiers",
    subPictures: [
      disneyBigShot1,
      disneyBigShot2,
      disneyBigShot3,
      disneyBigShot4,
    ],
  },
  {
    id: 18,
    image: deltaGrammy,
    eventName: "Delta Grammy Party",
    hashtag: "live show",
    subPictures: [deltaGrammy1],
  },
  {
    id: 19,
    image: lalaHathaway,
    eventName: "Lala Hathaway",
    hashtag: "live show",
    subPictures: [lalaHathaway1, lalaHathaway2, lalaHathaway3],
  },
  {
    id: 20,
    image: betMusicParty,
    eventName: "BET Music Party",
    hashtag: "live show",
    subPictures: [betMusicParty1, betMusicParty2],
  },
  {
    id: 21,
    image: amazonMusicGenMex,
    eventName: "Amazon Music Gen Mex",
    hashtag: "live show",
    subPictures: [
      amazonMusicGenMex1,
      amazonMusicGenMex2,
      amazonMusicGenMex3,
      amazonMusicGenMex4,
      amazonMusicGenMex5,
    ],
  },
  {
    id: 22,
    image: infectedMushroom,
    eventName: "Infected Mushroom",
    hashtag: "video production",
    subPictures: [
      infectedMushroom1,
      infectedMushroom2,
      infectedMushroom3,
      infectedMushroom4,
    ],
  },
  {
    id: 23,
    image: theBlackPowerLiveStream,
    eventName: "The Black Power",
    hashtag: "video production",
    subPictures: [theBlackPowerLiveStream1, theBlackPowerLiveStream2],
  },
  {
    id: 24,
    image: alisonJacksonMelissaRiversInterview,
    eventName: "Alison Jackson + Melissa Rivers",
    hashtag: "video production",
    subPictures: [
      alisonJacksonMelissaRiversInterview1,
      alisonJacksonMelissaRiversInterview2,
      alisonJacksonMelissaRiversInterview3,
    ],
  },
  {
    id: 25,
    image: InterviewProductionHboChad,
    eventName: "HBO Chad",
    hashtag: "video production",
    subPictures: [
      InterviewProductionHboChad1,
      InterviewProductionHboChad2,
      InterviewProductionHboChad3,
      InterviewProductionHboChad4,
    ],
  },
  {
    id: 26,
    image: videoProductionInvisiblePortraits,
    eventName: "Invisible Portraits",
    hashtag: "video production",
    subPictures: [
      videoProductionInvisiblePortraits1,
      videoProductionInvisiblePortraits2,
      videoProductionInvisiblePortraits3,
      videoProductionInvisiblePortraits4,
      videoProductionInvisiblePortraits5,
      videoProductionInvisiblePortraits6,
    ],
  },
  {
    id: 27,
    image: solanaHackerHouse,
    eventName: "Solana",
    hashtag: "corporate events",
    subPictures: [solanaHackerHouse1, solanaHackerHouse2, solanaHackerHouse3],
  },
  {
    id: 28,
    image: ekoAppLaunch,
    eventName: "EKO App Launch",
    hashtag: "corporate events",
    subPictures: [ekoAppLaunch1, ekoAppLaunch2, ekoAppLaunch3],
  },
  {
    id: 29,
    image: betAwards,
    eventName: "BET Awards",
    hashtag: "corporate events",
    subPictures: [betAwards1, betAwards2, betAwards3],
  },
  {
    id: 30,
    image: nbaLive,
    eventName: "NBA Live",
    hashtag: "corporate events",
    subPictures: [nbaLive1, nbaLive2, nbaLive3, nbaLive4, nbaLive5],
  },
  {
    id: 31,
    image: goCampaign,
    eventName: "GO Campaign",
    hashtag: "corporate events",
    subPictures: [goCampaign1],
  },
  {
    id: 32,
    image: netflixSquidGame,
    eventName: "Netflix Squid Game",
    hashtag: "premiers",
    subPictures: [
      netflixSquidGame1,
      netflixSquidGame2,
      netflixSquidGame3,
      netflixSquidGame4,
      netflixSquidGame5,
      netflixSquidGame6,
      netflixSquidGame7,
      netflixSquidGame8,
      netflixSquidGame9,
    ],
  },
  {
    id: 33,
    image: peacockDr,
    eventName: "Peacock Dr.Death",
    hashtag: "premiers",
    subPictures: [peacockDr1, peacockDr2, peacockDr3],
  },
  {
    id: 34,
    image: theFriendsReunion,
    eventName: "The Friends Reunion",
    hashtag: "premiers",
    subPictures: [theFriendsReunion1, theFriendsReunion2],
  },
  {
    id: 35,
    image: usaBriarpatch,
    eventName: "USA Briarpatch",
    hashtag: "premiers",
    subPictures: [
      usaBriarpatch1,
      usaBriarpatch2,
      usaBriarpatch3,
      usaBriarpatch4,
    ],
  },
  {
    id: 36,
    image: usaQueenOfTheSouth,
    eventName: "USA Queen of the South",
    hashtag: "premiers",
    subPictures: [usaQueenOfTheSouth1, usaQueenOfTheSouth2],
  },
  {
    id: 37,
    image: disneyZombies,
    eventName: "Disney Zombies 3",
    hashtag: "premiers",
    subPictures: [
      disneyZombies1,
      disneyZombies2,
      disneyZombies3,
      disneyZombies4,
      disneyZombies5,
      disneyZombies6,
      disneyZombies7,
      disneyZombies8,
      disneyZombies9,
      disneyZombies10,
    ],
  },
  {
    id: 38,
    image: amazonePrimeTheVoyeurs,
    eventName: "Amazone Prime The Voyeurs",
    hashtag: "premiers",
    subPictures: [
      amazonePrimeTheVoyeurs1,
      amazonePrimeTheVoyeurs2,
      amazonePrimeTheVoyeurs3,
      amazonePrimeTheVoyeurs4,
    ],
  },
  {
    id: 39,
    image: netflixStrangerThing,
    eventName: "Netflix Stranger Things",
    hashtag: "premiers",
    subPictures: [netflixStrangerThing1],
  },
  {
    id: 40,
    image: huluOnlyMurders,
    eventName: "Hulu Nine Perfect Strangers",
    hashtag: "premiers",
    subPictures: [huluOnlyMurders1, huluOnlyMurders2],
  },
  {
    id: 41,
    image: hboSuccession,
    eventName: "HBO Succession",
    hashtag: "premiers",
    subPictures: [hboSuccession1, hboSuccession2],
  },
  {
    id: 42,
    image: netfixArmyOfTheDead,
    eventName: "Netfix Army of the Dead",
    hashtag: "premiers",
    subPictures: [netfixArmyOfTheDead1, netfixArmyOfTheDead2],
  },
  {
    id: 43,
    image: fxHuluReservationDogs,
    eventName: "FX Hulu Reservation Dogs",
    hashtag: "premiers",
    subPictures: [fxHuluReservationDogs1, fxHuluReservationDogs2],
  },
  {
    id: 44,
    image: nationalGeographicTheRescue,
    eventName: "National Geographic The Rescue",
    hashtag: "premiers",
    subPictures: [nationalGeographicTheRescue1, nationalGeographicTheRescue2],
  },
  {
    id: 45,
    image: huluTheGreat,
    eventName: "Hulu The Great",
    hashtag: "premiers",
    subPictures: [huluTheGreat1, huluTheGreat2],
  },
  {
    id: 46,
    image: netflixGraceAndFrankie,
    eventName: "Netflix Grace and Frankie",
    hashtag: "premiers",
    subPictures: [netflixGraceAndFrankie1, netflixGraceAndFrankie2],
  },
  {
    id: 47,
    image: fxAmericanCrimeStoryVersace,
    eventName: "FX American Crime Story",
    hashtag: "premiers",
    subPictures: [fxAmericanCrimeStoryVersace1, fxAmericanCrimeStoryVersace2],
  },
  {
    id: 48,
    image: hboWeOwnThisCity,
    eventName: "HBO We own this city",
    hashtag: "premiers",
    subPictures: [hboWeOwnThisCity1, hboWeOwnThisCity2, hboWeOwnThisCity3],
  },
  {
    id: 49,
    image: iggyAzaleaForEmber,
    eventName: "Iggy Azalea for Ember",
    hashtag: "live show",
    subPictures: [iggyAzaleaForEmber1],
  },
  {
    id: 50,
    image: bigSeanAtPuma,
    eventName: "Big Sean at Puma",
    hashtag: "live show",
    subPictures: [bigSeanAtPuma1],
  },
  {
    id: 51,
    image: localNativesForSpotify,
    eventName: "Local Natives for Spotify",
    hashtag: "live show",
    subPictures: [
      localNativesForSpotify1,
      localNativesForSpotify2,
      localNativesForSpotify3,
    ],
  },
  {
    id: 52,
    image: leonBridgesAtDeltaGrammyParty,
    eventName: "Leon Bridges at Delta Grammy Party",
    hashtag: "live show",
    subPictures: [
      leonBridgesAtDeltaGrammyParty1,
      leonBridgesAtDeltaGrammyParty2,
    ],
  },
  {
    id: 53,
    image: piso21AtLatinAMAsFest,
    eventName: "Latin AMAs Fest",
    hashtag: "live show",
    subPictures: [
      piso21AtLatinAMAsFest1,
      piso21AtLatinAMAsFest2,
      piso21AtLatinAMAsFest3,
      piso21AtLatinAMAsFest4,
      piso21AtLatinAMAsFest5,
    ],
  },
  {
    id: 54,
    image: ukraineFilmFestival,
    eventName: "Ukraine Film Festival",
    hashtag: "corporate events",
    subPictures: [ukraineFilmFestival1, ukraineFilmFestival2],
  },
  {
    id: 55,
    image: clioCanabisAwards,
    eventName: "Clio Canabis Awards",
    hashtag: "corporate events",
    subPictures: [clioCanabisAwards1, clioCanabisAwards2],
  },
  {
    id: 56,
    image: teenVogueSummit,
    eventName: "Teen Vogue Summit",
    hashtag: "corporate events",
    subPictures: [teenVogueSummit1, teenVogueSummit2],
  },
];
